import momentTimezone from 'moment-timezone'

const TIMEZONE = 'Europe/Athens'

function isEmpty(value) {
    return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)
}

function toUtc(date) {
    return date.utc().format('YYYY-MM-DD[T]HH:mm:ss')
}

export function defaultFilterValues(fields) {
    return fields.reduce((values, field) => {
        values[field.key] = field.hasOwnProperty('default') ? field.default : null
        return values
    }, {})
}

// Converts the values of a TableFilters form into the backend filter object
// (see big-backend CustomSpecifications): text -> LIKE, dateRange -> Gte/Lte, rest -> equality
export function toFilterQuery(fields, values) {
    const filter = {}
    fields.forEach(field => {
        const value = values ? values[field.key] : null
        if (isEmpty(value)) {
            return
        }
        switch (field.type) {
        case 'number':
            if (!isNaN(Number(value))) {
                filter[field.key] = Number(value)
            }
            break
        case 'dateRange': {
            const [from, to] = [...value].sort()
            filter[`${field.key}Gte`] = toUtc(momentTimezone.tz(from, TIMEZONE).startOf('day'))
            filter[`${field.key}Lte`] = toUtc(momentTimezone.tz(to || from, TIMEZONE).endOf('day'))
            break
        }
        case 'boolean':
        case 'select':
        case 'autocomplete':
            filter[field.key] = value
            break
        default:
            filter[field.key] = `%${String(value).trim()}%`
        }
    })
    return filter
}

export function buildListQuery({ filter, page, size, sort } = {}) {
    const params = []
    if (filter && Object.keys(filter).length) {
        // The backend URL-decodes the filter a second time after Spring has already decoded it,
        // so a LIKE value such as "%Ace%" would otherwise be read as the escape "%Ac".
        params.push('filter=' + encodeURIComponent(encodeURIComponent(JSON.stringify(filter))))
    }
    if (page) {
        params.push('range=' + encodeURIComponent(JSON.stringify([page - 1, size])))
    }
    if (sort && sort.sortBy) {
        params.push('sort=' + encodeURIComponent(JSON.stringify([sort.sortBy, sort.sortDesc ? 'DESC' : 'ASC'])))
    }
    return params.length ? '?' + params.join('&') : ''
}
